module.exports = __webpack_public_path__ + "img/fast.d3921bea.png";